<template>
  <button
      type="button"
      class="service-card"
      :class="{
        'service-card--inactive': !service.isActive,
        'service-card--disabled': !hasRoute
      }"
      :style="cardStyle"
      @click="handleClick"
  >
    <span class="service-card__icon" :style="iconStyle">
      <svg :viewBox="iconViewBox" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            v-for="(path, index) in iconPaths"
            :key="index"
            :d="path"
            fill="currentColor"
        />
      </svg>
    </span>
    <span class="service-card__title">{{ service.label }}</span>
  </button>
</template>

<script>
export default {
  name: 'item-tariff-main',
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  emits: ['select'],
  computed: {
    hasRoute() {
      return Boolean(this.service.route);
    },
    iconViewBox() {
      return this.service.iconViewBox || '0 0 24 24';
    },
    iconPaths() {
      if (Array.isArray(this.service.iconPaths) && this.service.iconPaths.length) {
        return this.service.iconPaths;
      }
      return ['M4 12a8 8 0 1116 0A8 8 0 014 12zm7-4a1 1 0 012 0v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H8a1 1 0 110-2h3z'];
    },
    iconStyle() {
      return {
        color: this.service.color || '#4D61B7',
        backgroundColor: this.service.secondaryColor || 'rgba(77, 97, 183, 0.1)'
      };
    },
    cardStyle() {
      return {
        backgroundColor: this.service.secondaryColor || '#f7fafb'
      };
    }
  },
  methods: {
    handleClick() {
      if (!this.service.isActive || !this.hasRoute) {
        return;
      }
      this.$emit('select', this.service);
    }
  }
};
</script>

<style scoped>

.service-card {
  border: none;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 20px;
  background-color: transparent;
  transition: transform 0.2s ease, opacity 0.2s ease;
  cursor: pointer;
}


.service-card:hover {
  transform: translateY(-2px);
}

.service-card:active {
  transform: translateY(0);
}

.service-card--inactive {
  opacity: 0.55;
  cursor: default;
}

.service-card--inactive:hover {
  transform: none;
  box-shadow: none;
}

.service-card--disabled {
  cursor: default;
}

.service-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid currentColor;
}

.service-card__icon svg {
  width: 24px;
  height: 24px;
}

.service-card__title {
  display: block;
  text-align: center;
  font-family: 'Mont', serif;
  font-weight: 700;
  font-size: 0.9rem;
  color: #2b3a44;
  line-height: 1.2;
  white-space: nowrap;
}
</style>
